import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, FormControl, Input, InputLabel,
         MenuItem, NativeSelect, Paper, Select, Snackbar, SnackbarContent,
         TextField, Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address'

import BusinessIdentityCreateMutation from './BusinessIdentityCreateMutation';
import BusinessDocumentsFetch from './BusinessDocumentsFetch';
import CreditCard from '@mui/icons-material/CreditCard';

import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner';
import LoadingSpinner from '../ui/LoadingSpinner';
import PhoneNumberFormat from '../ui/PhoneNumberFormat';
import CountrySelect from '../ui/CountrySelect'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import AppBindStyles from '../../AppBindStyles';
import { green } from '@mui/material/colors';
import { differenceInYears, subYears } from 'date-fns';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    success: {
      backgroundColor: green[300],
    },
    error: {
      backgroundColor: theme.palette.error.light,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    close: {
      padding: theme.spacing(0.5),
    },
    select: {
      marginLeft: -8,
      marginTop: -8,
    },
    dateField: {
      width: 160,
    },
    businessClassification: {
      margin: theme.spacing(1),
    },
    instructText: {
      marginTop: 8,
    }
});
  
class BusinessIdentityCreate extends Component {

    state = {
        backupFunding: null,

        showSpinner: false,
        saveStatus: null,
        saveMessage: null,
        snackbarOpen: false,

        businessType: 'soleProprietorship',
        businessName: '',
        doingBusinessAs: '',
        website: '',
        ein: '',
        ipAddress: '',
        businessClassification: '',
        
        contactLastName: '',
        contactFirstName: '',
        contactEmail: '',
        contactPhone: '',
        dateOfBirth: null,
        ssn: '',

        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        postalCode: '',

        ctrTitle: '',
        ctrSsn: '', 
        ctrDateOfBirth: null,
        ctrPassportNumber: '',
        ctrPassportCountry: '',
        ctrLastName: '', 
        ctrFirstName: '', 
        ctrAddress1: '', 
        ctrAddress2: '', 
        ctrCity: '', 
        ctrState: '', 
        ctrCountry: '', 
        ctrPostalCode: '',
        dwollaList: []

    }

    componentDidMount() {

      let acctId = abEnvironment.getUserAttribute("a_id");
      BusinessDocumentsFetch.fetch(acctId).toPromise()
      .then(bdf => {

        //if business is set to verify business, make sure they don't have open items
        if (bdf.accountTByAccountId.achActive === 2) {
          let ccOnFile = false;
          var i = 0;
          for (i = 0; i < bdf.accountTByAccountId.paymentSourceTsByAccountId.nodes.length; i++) {

            let ps = bdf.accountTByAccountId.paymentSourceTsByAccountId.nodes[i];
            if (ps.psType === 0 && ps.psStatus === 0) {
              ccOnFile = true
            }

          }
          if (!ccOnFile) {
            this.setState({backupFunding: false});
          } else {
            this.setState({backupFunding: true});
           }

        
        } else {
          this.setState({backupFunding: false});

        }


      })
      .catch(err => {
       this.setState({backupFunding: false});
      })



      //see if there is data that was passed.
      let passedDataString = localStorage.getItem('tempVBParm');
      let passedData = null;
      if (passedDataString) {
        passedData = JSON.parse(passedDataString);
        this.setState({
          businessName: passedData.accountTByAccountId.accountName,
          doingBusinessAs: passedData.accountTByAccountId.accountName,
          contactLastName: passedData.accountTByAccountId.contactLastName,
          contactFirstName: passedData.accountTByAccountId.contactFirstName,
          contactEmail: passedData.accountTByAccountId.contactEmail,
  
          address1: passedData.accountTByAccountId.address1,
          address2: (passedData.accountTByAccountId.address2 !== null ? passedData.accountTByAccountId.address2: ''),
          city: passedData.accountTByAccountId.city,
          state: passedData.accountTByAccountId.state,
          country: passedData.accountTByAccountId.country,
          postalCode: passedData.accountTByAccountId.postalCode
  
        });
        //choice not to remove until they log off.  Page refresh causes problems because if dwolla exists, they cannot change
        //localStorage.removeItem('tempVBParm');
      } 
      this.callDwolla();
    }

    callDwolla() {
      const { callPartnerApi, logError } = this.props.auth;
   
      let aPjwt = abEnvironment.getPjwt();
  
      // Call server side ach form prep
      let payload = {
        operation: "listDwollaBusinessClassifications",
        params: {
          pJwt:      aPjwt
        }
      };
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      ).then(resp => {
        return resp.json();
      }).then(data => {

        let businessClassifications = data.body._embedded["business-classifications"];
        let extractedBc = [];
        for (var i = 0; i < businessClassifications.length; i++) {
          let industryName = businessClassifications[i].name;

          let industryClassifications = businessClassifications[i]._embedded["industry-classifications"];
          for (var y = 0; y < industryClassifications.length; y++) {
            let business = industryClassifications[y];

            let entry = {"id": business.id, "name": industryName + ' - ' + business.name};
            extractedBc.push(entry);
  
          }
  
        }
        this.setState({dwollaList: extractedBc});

      }).catch(reason => {
         logError('Exception in BusinessIdentityCreate.js: ' + reason);
      });      
    }

    handleBusinessChange = (event) => {
      this.setState({businessType: event.target.value})
    };

    goBack() {
      this.props.history.goBack();
    }
    
    goTo(route) {
      this.props.history.replace(`/${route}`);
    }
  
    showSpinner() {
        return this.state.showSpinner;
    }

    enableSave() {
      const { validateEmail } = this.props.auth;

      //first fields common to each type
      if (this.state.businessName == null || this.state.businessName.length === 0)
       return false;

      if (this.state.doingBusinessAs == null || this.state.doingBusinessAs.length === 0)
       return false;

      if (this.state.businessClassification == null || this.state.businessClassification.length === 0)
       return false;
       
      if (this.state.contactLastName == null || this.state.contactLastName.length === 0)
       return false;

      if (this.state.contactFirstName == null || this.state.contactFirstName.length === 0)
        return false;

      if (this.state.contactEmail == null || this.state.contactEmail.length === 0)
        return false;

      if (this.state.address1 == null || this.state.address1.length === 0)
        return false;

      if (this.state.city == null || this.state.city.length === 0)
        return false;

      if (this.state.state == null || this.state.state.length === 0)
        return false;

      if (this.state.country == null || this.state.country.length === 0)
        return false;

      if (this.state.postalCode == null || this.state.postalCode.length === 0)
        return false;
  
      // Is email an email address?
      let emailOk = validateEmail(this.state.contactEmail);
      if (! emailOk)
        return false;

      //now do fields special for each type
      if (this.state.businessType === 'soleProprietorship') {
        if (this.state.ssn == null || this.state.ssn.length === 0)
          return false;
        if (this.state.dateOfBirth == null || this.state.dateOfBirth.length === 0)
          return false;

        const age = differenceInYears(new Date(), new Date(this.state.dateOfBirth));
        if (age < 18) {
          return false;
        }
    
      } else {
        if (this.state.ein == null || this.state.ein.length === 0)
          return false;

        //validate ein is 9
        var re = /^\d{9}$/;
        if (!re.test(this.state.ein)) {
          return false;
        }
        
        if ((this.state.ctrSsn == null || this.state.ctrSsn.length === 0) && this.state.ctrCountry === "US")
          return false;

        if (this.state.ctrTitle == null || this.state.ctrTitle.length === 0)
          return false;

        if (this.state.ctrDateOfBirth == null || this.state.ctrDateOfBirth.length === 0)
          return false;

        const age = differenceInYears(new Date(), new Date(this.state.dateOfBirth));
        if (age < 18) {
          return false;
        }
  
        if (this.state.ctrAddress1 == null || this.state.ctrAddress1.length === 0)
          return false;
  
        if (this.state.ctrCity == null || this.state.ctrCity.length === 0)
          return false;
  
        if (this.state.ctrState == null || this.state.ctrState.length === 0)
          return false;
  
        if (this.state.ctrCountry == null || this.state.ctrCountry.length === 0)
          return false;
  
        if (this.state.ctrPostalCode == null || this.state.ctrPostalCode.length === 0)
          return false;
  
        if (this.state.ctrCountry !== "US") {
          if (this.state.ctrPassportCountry == null || this.state.ctrPassportCountry.length === 0)
            return false;
          if (this.state.ctrPassportNumber == null || this.state.ctrPassportNumber.length === 0)
            return false;
          
        }
      }

      return true;
    }

    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

    setCtrCountry    = (country)    => { this.setState({ctrCountry:    country}); }  
    setCtrRegion     = (region)     => { this.setState({ctrState:      region}); }  
    setCtrCity       = (city)       => { this.setState({ctrCity:       city}); }  
    setCtrPostalCode = (postalCode) => { this.setState({ctrPostalCode: postalCode}); }  
    setCtrAddress1   = (address1)   => { this.setState({ctrAddress1:   address1}); }  
    setCtrAddress2   = (address2)   => { this.setState({ctrAddress2:   address2}); }  
    setPassportCountry    = (country)    => { this.setState({ctrPassportCountry:    country}); }  

    handleSnackbarClose = (event, reason) => { 
      this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
    };

    render() {
        const { validateEmail, isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedReseller()) {

          if (this.state.backupFunding === null) {
            return (
              <div>
                <Typography>Loading...</Typography>
                <LoadingSpinner/>
              </div>
            );
          } else if (this.state.backupFunding === false) {
            return (
              
              <div>
                <Typography>Before starting ACH business verification, please connect a credit card as backup to your account</Typography>

                <Typography variant="body2" className={classes.instructText}>
                    Go to <Button color="primary"  size="small" variant="outlined" className={classes.instructButton}
                          onClick={this.goTo.bind(this, 'fundingsources')}>
                          <CreditCard className={classes.buttonicon}/> My Funding
                </Button> to add a backup funding source. 
              </Typography>
            </div>
            );
          }

          let acctId = abEnvironment.getUserAttribute("a_id");
    
          const params = new URLSearchParams(this.props.location.search);
          let dwollaCid = params.get('dId');
          let protectContact = false;
          if (dwollaCid) {
            protectContact = true;
          }

          // Fill the prop values...
          let address = {
            country:    this.state.country,
            state:      this.state.state,
            city:       this.state.city,
            postalCode: this.state.postalCode,
            address1:   this.state.address1,
            address2:   this.state.address2
          };
          let ctrAddress = {
            country:    this.state.ctrCountry,
            state:      this.state.ctrState,
            city:       this.state.ctrCity,
            postalCode: this.state.ctrPostalCode,
            address1:   this.state.ctrAddress1,
            address2:   this.state.ctrAddress2
          };
          let regionLabel = "Region";

          let emailError = false;
          if (this.state.contactEmail != null && this.state.contactEmail !== '') {
            let emailOk = validateEmail(this.state.contactEmail);
            if (! emailOk) {
              emailError = true;
            }
          }                

          let soleP = this.state.businessType === 'soleProprietorship';

          // Determine the maximum date.  So 18 years ago
          let theMaxDate = subYears(new Date(), 18);
          
          let einErrorText = '';
          if (!soleP && this.state.ein ) {
            //validate ein is 9
            var re = /^\d{9}$/;
            if (this.state.ein && !re.test(this.state.ein)) {
              einErrorText = 'EIN must be 9 numbers no dashes'
            }
          }

          return (
            <div id="business-identity-create" className={classes.root}>
              <PageTitle title="Add your business identity" showBackButton={true} name="Company info" history={this.props.history}/>

              <Paper className={classes.paper}>
                <Grid container spacing={2} direction="row" justifyContent="flex-start">
 
                 <Grid item xs={12} sm={6}>
                    <FormControl required variant="standard" className={classes.formControl}>
                      <InputLabel id="business-type">Business type</InputLabel>
                      <Select
                        labelId="dbusiness-type-select-required-label"
                        id="business-type-select-required"
                        value={this.state.businessType}
                        onChange={this.handleBusinessChange}
                      >
                        <MenuItem value={'soleProprietorship'}>Sole proprietorship</MenuItem>
                        <MenuItem value={'corporation'}>Corporation</MenuItem>
                        <MenuItem value={'llc'}>Limited liability corporation</MenuItem>
                        <MenuItem value={'partnership'}>Partnership</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                 <Grid item xs={12}>
                    <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                      Account
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="customer-name" label="Business name *"
                      value={ this.state.businessName }
                      onChange={ (e) => this.setState({ businessName: e.target.value }) }
                      inputProps={{ maxLength: 64 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                     id="dba" label="Doing business as *"
                     value={ this.state.doingBusinessAs }
                     onChange={ (e) => this.setState({ doingBusinessAs: e.target.value }) }
                     inputProps={{ maxLength: 64 }}
                   />
                 </Grid>

                  { !soleP &&
                    <Grid item xs={12} sm={6}>
                      <TextField data-recording-ignore="mask"
                      id="ein" label="EIN (no dashes) *"
                      value={ this.state.ein }
                      onChange={ (e) => this.setState({ ein: e.target.value }) }
                      inputProps={{ maxLength: 9 }}
                      error={einErrorText !== ''}
                      helperText={einErrorText}
                  />
                    </Grid>
                  }
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="website" label="Web site"
                      value={ this.state.website }
                      onChange={ (e) => this.setState({ website: e.target.value }) }
                      inputProps={{ maxLength: 128 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
 
                  </Grid>
                  <Grid >
                    <FormControl  variant="standard"
                        className={classes.businessClassification}
                      >
                      <InputLabel shrink htmlFor="businessClassification">Business classification *</InputLabel>
                      <NativeSelect
                        value={ this.state.businessClassification }
                        input={<Input name="businessClassification" id="country" />}
                        onChange={(e) => this.setState({ businessClassification: e.target.value })}
                        className={classes.nselect}
                      >
                        <option key="" value="">Select a classification</option>
                        {this.state.dwollaList.map(n => {
                          return(<option key={n.id} value={n.id}>{n.name}</option>);
                        })}
                      </NativeSelect>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                      Primary contact
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField  data-recording-ignore="mask"
                      id="first-name" label="First name *"
                      value={ this.state.contactFirstName }
                      onChange={ (e) => this.setState({ contactFirstName: e.target.value }) }
                      inputProps={{ maxLength: 32 }}
                      InputProps={{ readOnly: protectContact, disableUnderline: protectContact }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField  data-recording-ignore="mask"
                      id="last-name" label="Last name *"
                      value={ this.state.contactLastName }
                      onChange={ (e) => this.setState({ contactLastName: e.target.value }) }
                      inputProps={{ maxLength: 32 }}
                      InputProps={{ readOnly: protectContact, disableUnderline: protectContact }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                  
                    <TextField  data-recording-ignore="mask"
                      id="email" label="Email *"
                      error={emailError}
                      value={ this.state.contactEmail }
                      onChange={ (e) => this.setState({ contactEmail: e.target.value }) }
                      InputProps={{ readOnly: protectContact, disableUnderline: protectContact }}
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <TextField  data-recording-ignore="mask"
                      id="phone" label="Contact phone" 
                      value={ this.state.contactPhone }
                      onChange={ (e) => this.setState({ contactPhone: e.target.value }) }
                      InputProps={{
                        inputComponent: PhoneNumberFormat
                      }}
                    />
                  </Grid>
                  { soleP &&
                  <Grid item xs={12} sm={6}>
                    <div style={AppBindStyles.datePickerField}>
                    <DatePicker data-recording-ignore="mask"
                      autoOk
                      label="Date of birth *"
                      value={ this.state.dateOfBirth }
                      onChange={(date) => this.setState({ dateOfBirth: date }) }
                      className={classes.dateField}
                      format="YYYY-MM-DD"
                      maxDate={theMaxDate}
                      maxDateMessage="Business owner must be over 18"
                      renderInput={(params) => <TextField {...params} />}
                    />
                    </div>
                  </Grid>
                  }
                  { soleP &&
                    <Grid item xs={12} sm={6}>
                      <TextField data-recording-ignore="mask"
                      id="ssn" label="Last 4 SSN *"
                      value={ this.state.ssn }
                      onChange={ (e) => this.setState({ ssn: e.target.value }) }
                    />
                    </Grid>
                  }
                  <Grid item xs={12}>
                    <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                      Business mailing address
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Address
                      showRequired={true}
                      address={address}
                      regionLabel={regionLabel}
                      setCountryCodeState={this.setCountry}
                      setRegionCodeState={this.setRegion}
                      setCityState={this.setCity}
                      setPostalCodeState={this.setPostalCode}
                      setAddress1State={this.setAddress1}
                      setAddress2State={this.setAddress2}
                    />
                  </Grid>
                  { !soleP &&
                  <React.Fragment>
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                        Controller
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="ctr-first-name" label="First name *"
                        value={ this.state.ctrFirstName }
                        onChange={ (e) => this.setState({ ctrFirstName: e.target.value }) }
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="ctr-last-name" label="Last name *"
                        value={ this.state.ctrLastName }
                        onChange={ (e) => this.setState({ ctrLastName: e.target.value }) }
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>
                                        
                    <Grid item xs={12} sm={6}>
                      <div style={AppBindStyles.datePickerField}>
                      <DatePicker data-recording-ignore="mask"
                        autoOk
                        label="Date of birth *"
                        value={ this.state.ctrDateOfBirth } 
                        onChange={(date) => this.setState({ ctrDateOfBirth: date }) }
                        className={classes.dateField}
                        format="YYYY-MM-DD"
                        maxDate={theMaxDate}
                        maxDateMessage="Business owner must be over 18"
                        renderInput={(params) => <TextField {...params} />}
                      />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                        id="ctr-ssn" label={"Last 4 SSN " + ((this.state.ctrCountry === "US") ? " *"  : "")}
                        value={ this.state.ctrSsn }
                        onChange={ (e) => this.setState({ ctrSsn: e.target.value }) }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                        id="ctr-title" label="Title *"
                        value={ this.state.ctrTitle }
                        onChange={ (e) => this.setState({ ctrTitle: e.target.value }) }
                      />
                    </Grid>


                    <Grid item xs={12}>
                      <Address
                        showRequired={true}
                        address={ctrAddress}
                        regionLabel={regionLabel}
                        setCountryCodeState={this.setCtrCountry}
                        setRegionCodeState={this.setCtrRegion}
                        setCityState={this.setCtrCity}
                        setPostalCodeState={this.setCtrPostalCode}
                        setAddress1State={this.setCtrAddress1}
                        setAddress2State={this.setCtrAddress2}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField data-recording-ignore="mask"
                        id="ppnumber" label={"Passport number" + ((this.state.ctrCountry !== "US") ? " *"  : "")}
                        value={ this.state.ctrPassportNumber }
                        onChange={ (e) => this.setState({ ctrPassportNumber: e.target.value }) }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                    <div className={classes.select}>
                      <CountrySelect data-recording-ignore="mask"
                        overrideLabel={'Passport country'}
                        showRequired={(this.state.ctrCountry !== "US")}
                        countryCode={this.state.ctrPassportCountry}
                        setCountryCodeState={this.setPassportCountry}
                        
                      />
                    </div>
                    </Grid>

                  </React.Fragment>
                  }


                  <Grid item xs={12}>
                  <div style={{display:'inline'}}>
                    { !this.showSpinner()  && this.enableSave() &&
                    <Button variant="contained" style={AppBindStyles.bottomButton}  onClick={() => {this._createBusinessEntity(acctId)}}>
                      Save
                    </Button>
                    }
                    { ((!this.showSpinner() && !this.enableSave())) &&
                    <Button variant="contained" disabled  style={AppBindStyles.bottomButton} >
                      Save
                    </Button>
                    }
                    { this.showSpinner() &&
                    <Button disabled={false} color="primary" variant="contained"  style={AppBindStyles.bottomButton} >
                      <SavingSpinner/></Button> }
                    
 
                      <Snackbar
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                        }}
                        open={this.state.snackbarOpen}
                        onClose={this.handleSnackbarClose}
                      >
                        <SnackbarContent
                          className={classNames(classes.message, classes[this.state.saveStatus])}
                          onClose={this.handleSnackbarClose}
                          message={
                            <Typography variant="body1">
                                {this.state.saveMessage}
                            </Typography>
                          }
                          action={[
                            <IconButton
                              key="close"
                              aria-label="Close"
                              color="inherit"
                              className={classes.close}
                              onClick={this.handleSnackbarClose}
                              size="large">
                            <CloseIcon />
                          </IconButton>
                        ]}
                      />
                    </Snackbar>

                  </div>

                  </Grid>
                </Grid>
              </Paper>

            </div>
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    _createBusinessEntity = (accountId) => {
      const { logError } = this.props.auth;

      //if (abEnvironment.isSegmentActive()) { window.analytics.track('Customer create saving customer'); }   
      let existingDwollaId = abEnvironment.getUserAttribute("a_dwollaCid");

      this.setState({ showSpinner: true });
      const { businessName, doingBusinessAs, businessType, businessClassification, website, ein, ipAddress, ssn, dateOfBirth,
        contactLastName, contactFirstName, contactEmail, contactPhone, address1, address2, city, state, country, postalCode,
        ctrTitle, ctrSsn, ctrDateOfBirth, ctrPassportNumber, ctrPassportCountry, ctrLastName, ctrFirstName, 
        ctrAddress1, ctrAddress2, ctrCity, ctrState, ctrCountry, ctrPostalCode } = this.state;
      
      let theBiId = null;

      let newBirthDate = dateOfBirth;
      if (newBirthDate === '') {
        newBirthDate = null;
      }
      let newCtrBirthDate = ctrDateOfBirth;
      if (newCtrBirthDate === '') {
        newCtrBirthDate = null;
      }

      BusinessIdentityCreateMutation.commit(accountId, businessName, doingBusinessAs, businessType, businessClassification, website, ein, ipAddress, ssn, newBirthDate,
        contactLastName, contactFirstName, contactEmail, contactPhone, address1, address2, city, state, country, postalCode,
        ctrTitle, ctrSsn, newCtrBirthDate, ctrPassportNumber, ctrPassportCountry, ctrLastName, ctrFirstName, 
        ctrAddress1, ctrAddress2, ctrCity, ctrState, ctrCountry, ctrPostalCode)
      .then(response => {
        theBiId = response.createBusinessIdentityT.businessIdentityT.biId;

        
        return null;
      })
      .then(response => {
        localStorage.setItem('vsuccess', 'ss');
        this.setState({ showSpinner: false });
        let url = 'businessidentityedit?biId=' + theBiId;
        if (existingDwollaId) {
          url = url + '&dId=' + existingDwollaId;
        }

        this.goTo(url);
      })
      .catch(error => {
        logError('Exception in BusinessIdentifyCreate.js: ' + error);
        this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save business identity.' });
        // this.goBack();
      });
    }


}

BusinessIdentityCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(BusinessIdentityCreate);